<template>
  <div v-loading.body="loading" element-loading-text="加载中..." class="app-container">
    <el-card shadow="never" :body-style="{ padding: 0 }" class="sticky-container">
      <template slot="header">
        <el-tabs v-model="queryParams.status" @tab-click="handleFilter">
          <el-tab-pane label="全部" name="" />
          <el-tab-pane label="审核中" name="2" />
          <el-tab-pane label="提现成功" name="1" />
          <el-tab-pane label="提现失败" name="3" />
        </el-tabs>

        <el-form label-width="100px">
          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item label="时间选择：">
                <el-radio-group v-model="dateText" type="button" class="flex-row" @change="dateRangeChange">
                  <el-radio-button v-for="(item, index) in dateSelect" :key="index" :label="item.value">{{ item.text }}</el-radio-button>
                  <el-date-picker v-model="timeRange" :editable="false" value-format="yyyy-MM-dd" format="yyyy-MM-dd" type="daterange" range-separator="至" @change="timeRangeChange" />
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :sm="24" :md="8">
              <el-form-item label="关键词：">
                <el-input v-model="queryParams.keyword" placeholder="用户昵称、手机号、分享码" clearable />
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item class="last-form-item">
            <el-button type="primary" icon="el-icon-search" @click="handleFilter">查找</el-button>
          </el-form-item>
        </el-form>
      </template>

      <el-table v-sticky-header stripe fit highlight-current-row :data="list" header-cell-class-name="table-header-cell">
        <el-table-column label="序号" width="60" align="center" type="index" class-name="table-header-cell">
          <template slot-scope="scope">
            <span>{{ (scope.$index + 1) + (queryParams.page - 1) * queryParams.limit }}</span>
          </template>
        </el-table-column>
        <el-table-column label="用户信息" min-width="150">
          <template slot-scope="{row}">
            <div class="mb-5"><span class="bold">编号：</span>{{ row.shareCode }}</div>
            <div class="mb-5"><span class="bold">昵称：</span>{{ row.nickName }}</div>
            <div><span class="bold">手机：</span>{{ row.mobile }}</div>
          </template>
        </el-table-column>
        <el-table-column label="应付金额" prop="amount" width="80" align="right">
          <template slot-scope="{row}">
            <span class="bold">{{ row.amount }}</span>
          </template>
        </el-table-column>
        <el-table-column label="提现方式" prop="extractType" width="80" align="center">
          <template slot-scope="{row}">
            <span v-if="row.extractType == 'bank'">银行卡</span>
            <span v-else-if="row.extractType == 'alipay'">支付宝</span>
            <span v-else>微信</span>
          </template>
        </el-table-column>
        <el-table-column label="提现账号 / 二维码" min-width="150">
          <template slot-scope="{row}">
            <template v-if="row.extractType === 'bank'">
              <div class="mb-5"><span class="bold">开户名：</span>{{ row.extractName }}</div>
              <div class="mb-5"><span class="bold">银行账号：</span>{{ row.extractCode }}</div>
              <div><span class="bold">开户银行：</span>{{ row.bankName }}</div>
            </template>
            <template v-else>
              <el-image class="td-image" :src="row.extractCode" :preview-src-list="[row.extractCode]" lazy />
            </template>
          </template>
        </el-table-column>
        <el-table-column label="状态" prop="statusName" width="80" align="center" />
        <el-table-column label="备注" prop="reason" min-width="80" />
        <el-table-column label="提现时间" prop="createTime" width="150" align="center" />
        <el-table-column label="提现金额" prop="totalAmount" width="80" align="right" />
        <el-table-column label="手续费" prop="taxFee" width="80" align="right" />
        <el-table-column label="操作" align="center" width="80" fixed="right">
          <template slot-scope="{row}">
            <span v-if="row.status == 1">无</span>
            <el-button v-else type="text" size="small" @click="editExtract(row)">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination :total="total" :page.sync="queryParams.page" :limit.sync="queryParams.limit" @pagination="fetchData" />
    </el-card>
    <el-dialog title="提示" :visible.sync="dialogVisible" custom-class="dialog-message-box">
      <el-form :model="dialog" size="large" label-position="top">
        <el-form-item label="请输入备注信息" prop="reason">
          <el-input v-model="dialog.reason" placeholder="请输入备注信息" />
        </el-form-item>
        <el-form-item label="支付存根图片" prop="counterfoil">
          <el-upload
            ref="uploader"
            action="#"
            accept="image/*"
            class="avatar-uploader"
            :auto-upload="false"
            :show-file-list="false"
            :on-change="voucherFileChange"
            :http-request="voucherUpload"
          >
            <img v-if="voucherUrl" :src="voucherUrl" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon" />
          </el-upload>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="handleCancel">拒 绝</el-button>
        <el-button size="small" type="primary" @click="handleOk">发放提现</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { StickyHeader } from '@cell-x/el-table-sticky'
import Pagination from '@/components/Pagination'
import { getExtractRecords, auditMemberExtractInfo } from '@/api/finance'
import { uploadToLocal } from '@/api/oss'

export default {
  name: 'FinanceIndex',
  components: { Pagination },
  directives: {
    StickyHeader: new StickyHeader({ offsetTop: 0, offsetBottom: 0 }).init()
  },
  data() {
    return {
      list: [],
      total: 0,
      loading: false,
      dateSelect: [
        { text: '全部', value: 'all' },
        { text: '今天', value: 'today' },
        { text: '昨天', value: 'yesterday' },
        { text: '最近7天', value: 'lastSeven' },
        { text: '最近30天', value: 'lastThirty' },
        { text: '本月', value: 'month' },
        { text: '本年', value: 'year' }
      ],
      dateText: 'all',
      timeRange: undefined,
      queryParams: {
        keyword: undefined, // 关键词（用户昵称、手机号、分享码）
        dateRange: undefined, // 下单日期范围
        dateStart: undefined,
        dateEnd: undefined,
        status: undefined,
        page: 1,
        limit: 20
      },
      extractInfo: null,
      dialog: {
        id: undefined,
        status: 0,
        reason: undefined,
        counterfoil: undefined
      },
      voucherUrl: undefined,
      voucherFile: null,
      dialogVisible: false
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    handleFilter() {
      this.queryParams = Object.assign({}, this.queryParams, {
        dateRange: this.dateText === 'all' ? undefined : this.dateText,
        dateStart: this.timeRange ? this.timeRange[0] : undefined,
        dateEnd: this.timeRange ? this.timeRange[1] : undefined,
        page: 1
      })
      console.log(this.queryParams)
      this.fetchData()
    },
    fetchData() {
      this.loading = true
      getExtractRecords(this.queryParams).then(response => {
        this.list = response.records
        this.total = response.total
      }).finally(() => {
        this.$util.delay().then(() => { this.loading = false })
      })
    },
    dateRangeChange() {
      this.timeRange = ''
    },
    timeRangeChange() {
      this.dateText = this.timeRange ? '' : 'all'
    },
    editExtract(record) {
      this.dialog.reason = ''
      this.dialog.id = record.id
      this.dialog.counterfoil = ''
      this.dialog.status = record.status

      this.extractInfo = record
      this.dialogVisible = true
    },
    voucherFileChange(file) {
      if (file) {
        this.voucherUrl = URL.createObjectURL(file.raw)
        this.dialog.counterfoil = this.voucherUrl
      }
    },
    voucherUpload(form) {
      if (!this.voucherFile) this.voucherFile = new FormData()
      this.voucherFile.append('file', form.file)
      this.voucherFile.append('name', form.file.name)
      this.voucherFile.append('fileSize', form.file.size)
      this.voucherFile.append('fileType', form.file.type)
    },
    handleCancel() {
      if (!this.dialog.reason) return this.$message.error('请输入拒绝原因')

      this.dialog.status = 3  // 拒绝
      this.handleSubmit()
      this.dialogVisible = false
    },
    handleOk() {
      // 上传商品图片
      setTimeout(async() => {
        this.$refs.uploader.submit()
        if (this.voucherFile) {
          this.dialog.counterfoil = await uploadToLocal(this.voucherFile)
          this.$refs.uploader.clearFiles()
          this.voucherFile = null
        }
        this.dialog.status = 1  // 已发放
        this.handleSubmit()
        this.dialogVisible = false
      }, 100)
    },
    handleSubmit() {
      auditMemberExtractInfo(this.dialog).then(response => {
        this.$message.success('数据提交成功')
        const index = this.list.query(response.id, 'id')
        if (index >= 0) this.list.splice(index, 1, response)
      }).catch(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>
  .td-image {
    width: 100px;
    height: 100px;
    border-radius: 4px;
    font-size: 0;
    line-height: 1;
  }
</style>
